import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _isNil from "lodash/isNil";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import { EXPERIMENT_SETTINGS_QC_START, EXPERIMENT_SETTINGS_DISCARD_CHANGED_QC_FILTERS } from 'redux/actionTypes/experimentSettings';
import { deleteExcludeGenesFileUpload, saveProcessingSettings } from 'redux/actions/experimentSettings';
import { loadBackendStatus } from 'redux/actions/backendStatus';
import { loadEmbedding } from 'redux/actions/embedding';
import { runCellSetsClustering } from 'redux/actions/cellSets';
import { getBackendStatus, getFilterChanges } from 'redux/selectors';
import { analysisTools } from 'const';
var runOnlyConfigureEmbedding = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(experimentId, embeddingMethod, dispatch) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return dispatch(saveProcessingSettings(experimentId, 'configureEmbedding'));
        case 2:
          dispatch({
            type: EXPERIMENT_SETTINGS_DISCARD_CHANGED_QC_FILTERS,
            payload: {}
          });

          // Only configure embedding was changed so we run loadEmbedding
          dispatch(loadEmbedding(experimentId, embeddingMethod, true));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function runOnlyConfigureEmbedding(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var runOnlyClustering = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(experimentId, resolution, dispatch) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return dispatch(saveProcessingSettings(experimentId, 'configureEmbedding'));
        case 2:
          dispatch({
            type: EXPERIMENT_SETTINGS_DISCARD_CHANGED_QC_FILTERS,
            payload: {}
          });

          // Only configure embedding was changed so we run loadEmbedding
          dispatch(runCellSetsClustering(experimentId, resolution));
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function runOnlyClustering(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

// Question for review, I thought of implementing this function for all the URLs here
// (extracting all the URLs into one single place and using constants to
//  define which url I am trying to access)
// Since it is a lot of changes, I didn't want to do it before first
//  getting an opinion on this in review
// I want to do it btw)
// It would also work nicely with isUserAuthorized, instead of passing a url
//  we could pass the constant that corresponds to this
var getURL = function getURL(experimentId) {
  return "/v2/experiments/".concat(experimentId, "/qc");
};
var runQC = function runQC(experimentId) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var processing, qcFailed, excludeGenesIdPrev, excludeGenesIdNext, changedQCFilters, analysisTool, onlyConfigureEmbeddingChanged, changedKeys, clusteringSettings, processingConfigDiff, errorMessage;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            processing = getState().experimentSettings.processing;
            qcFailed = getBackendStatus(experimentId)(getState()).status.pipeline.error;
            excludeGenesIdPrev = getState().experimentSettings.originalProcessing.dataIntegration.dimensionalityReduction.excludeGenesId;
            excludeGenesIdNext = getState().experimentSettings.processing.dataIntegration.dimensionalityReduction.excludeGenesId; // handle exclude genes file delete before starting pipeline
            if (!(!_isNil(excludeGenesIdPrev) && _isNil(excludeGenesIdNext))) {
              _context3.next = 7;
              break;
            }
            _context3.next = 7;
            return dispatch(deleteExcludeGenesFileUpload(experimentId));
          case 7:
            changedQCFilters = processing.meta.changedQCFilters;
            analysisTool = processing.dataIntegration.analysisTool;
            onlyConfigureEmbeddingChanged = changedQCFilters.has('configureEmbedding') && changedQCFilters.size === 1; // if only embedding changed and the qc didn't fail
            if (!(analysisTool === analysisTools.SEURAT && onlyConfigureEmbeddingChanged && !qcFailed)) {
              _context3.next = 15;
              break;
            }
            changedKeys = getFilterChanges('configureEmbedding')(getState());
            if (changedKeys.has('embeddingSettings')) {
              runOnlyConfigureEmbedding(experimentId, processing.configureEmbedding.embeddingSettings.method, dispatch);
            }
            if (changedKeys.has('clusteringSettings')) {
              clusteringSettings = processing.configureEmbedding.clusteringSettings;
              runOnlyClustering(experimentId, clusteringSettings.methodSettings[clusteringSettings.method].resolution, dispatch);
            }
            return _context3.abrupt("return");
          case 15:
            processingConfigDiff = {};
            Array.from(changedQCFilters).forEach(function (stepKey) {
              var stepConfig = processing[stepKey];
              processingConfigDiff[stepKey] = stepConfig;
            });
            _context3.prev = 17;
            _context3.next = 20;
            return fetchAPI(getURL(experimentId), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                processingConfigDiff: processingConfigDiff
              })
            });
          case 20:
            dispatch({
              type: EXPERIMENT_SETTINGS_QC_START,
              payload: {}
            });
            dispatch(loadBackendStatus(experimentId));
            return _context3.abrupt("return", true);
          case 25:
            _context3.prev = 25;
            _context3.t0 = _context3["catch"](17);
            errorMessage = handleError(_context3.t0, endUserMessages.ERROR_STARTING_PIPLELINE); // get the backend status only if the error is not  a permission issue
            if (errorMessage !== endUserMessages.ERROR_NO_PERMISSIONS) {
              dispatch(loadBackendStatus(experimentId));
            }
            return _context3.abrupt("return", false);
          case 30:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[17, 25]]);
    }));
    return function (_x7, _x8) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export { getURL };
export default runQC;